//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    workShift: {
      type: Array,
      default: null
    },
    zoomSize: {
      type: Number,
      default: 1.0
    }
  },
  data: function () {
    return {

    }
  },
  methods: {
    getIconName: function (name) {
      let nameIcon = 'mdi-clock-outline'
      switch (name) {
        case 'Утренний медосмотр':
          nameIcon = 'mdi-weather-sunny'
          break
        case 'Вечерний медосмотр':
          nameIcon = 'mdi-weather-night'
          break
        default:
          nameIcon = 'mdi-clock-outline'
          break
      }
      return nameIcon
    },
    getIconColor: function (name) {
      let color = 'text-grey-9'
      switch (name) {
        case 'Утренний медосмотр':
          color = 'text-yellow'
          break
        default:
          color = 'text-grey-9'
          break
      }
      return color
    }
  }
}
